import { render, staticRenderFns } from "./cBScroll.vue?vue&type=template&id=655a2111&lang=pug"
import script from "./cBScroll.vue?vue&type=script&lang=js"
export * from "./cBScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports